// extracted by mini-css-extract-plugin
export default {"row":"SummaryRow_row__pCznq","label":"SummaryRow_label__yQqqc","count":"SummaryRow_count__D8hr+","chevron":"SummaryRow_chevron__qVgg3"};